import { axiosCall } from "../../utils/axiosCall";

function initialState() {
  return {
    status: {
      pillars: "",
    },
    reportData: {},
    pillarsIds: [],
    pillarsData: [],
    generalIndex: 0,
    currentPillarId: null,
    currentIndicatorId: null,
  };
}

const state = initialState;

const getters = {
  getPillars: (state) => state.invitations,
  reportData: (state) => state.reportData,
  numberOfPillars: (state) => state.pillarsData.length,
  pillarsIds: (state) => state.pillarsIds,
  pillarGlobalIds: (state) => state.pillarGlobalIds,
  pillarsData: (state) => () => state.pillarsData,
  generalIndex: (state) => state.generalIndex,
  pillarData: (state) => (pillarId) => {
    return state.pillarsData.find((x) => x.id === pillarId);
  },
  indicatorsDataByPillarId: (state) => (pillarId) => {
    return state.pillarsData.find((x) => x.id === pillarId).children;
  },
  getIndicatorData: (state) => (pillarId, indicatorId) => {
    const indicator = state.pillarsData.find((x) => x.id === pillarId);
    return indicator
      ? indicator.children.find((x) => x.id === indicatorId)
      : null;
  },
  currentPillarId: (state) => state.currentPillarId,
  currentIndicatorId: (state) => state.currentIndicatorId,
  getColorStateValue: () => (value, ranges, errorOnValueFormula) => {
    if (errorOnValueFormula === "true") {
      return "notAvailable";
    }
    if (
      (value >= ranges.negMin1 && value <= ranges.negMax1) ||
      (value >= ranges.negMin2 && value <= ranges.negMax2) ||
        (ranges.negMax2 !== null && value > ranges.negMax2) ||
        (ranges.negMin1 !== null && value < ranges.negMin1)
    ) {
      return "negative";
    } else if (
      (value >= ranges.interMin1 && value <= ranges.interMax1) ||
      (value >= ranges.interMin2 && value <= ranges.interMax2)
    ) {
      return "intermediate";
    } else {
      return "positive";
    }
  },
  getColorStateIndex: () => (value, errorOnValueFormula) => {
    if (errorOnValueFormula === "true") {
      return "notAvailable";
    }
    if (value > 75) {
      return "positive";
    } else if (value > 50) {
      return "intermediate";
    } else {
      return "negative";
    }
  },
};

const actions = {
  PILLARS_GLOBAL_IDS_GET: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axiosCall({ url: "Pillars" })
        .then((response) => {
          commit("setPillarGlobalIds", response.data);
        })
        .catch((err) => {
          commit("setPillarsStatus", { status: "error", key: "pillars" });
          reject(err);
        });
    });
  },
  PILLARS_GET: ({ commit, rootState }) => {
    // Consulta el endpoint que tiene la información del reporte
    // Se hace una sola consulta para opmitizar recursos, tiempos de descarga
    // Y para facilitar la renderización de información en los componentes creados
    return new Promise((resolve, reject) => {
      commit("setPillarsStatus", { status: "pending", key: "pillars" });
      const businessId = rootState.business.currentBusiness.id;
      const snapshot = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Pillars/get/" + businessId + "/" + snapshot })
        .then((resp) => {
          commit("setPillarsStatus", { status: "success", key: "pillars" });
          var pillars = resp.data.pillars.children;
          var pillarsIds = [];
          for (const pillar in pillars) {
            pillarsIds.push(pillars[pillar].id);
          }
          commit("setReportData", resp.data);
          commit("setPillarsData", pillars);
          commit("setPillarsIds", pillarsIds);
          commit("setCurrentPillarId", "OP");
          commit("setCurrentIndicatorId", "OP1");
          commit("setGeneralIndex", resp.data.generalIndex);
          resolve(resp);
        })
        .catch((err) => {
          commit("setPillarsStatus", { status: "error", key: "pillars" });
          reject(err);
        });
    });
  },
  PILLARS_GET_REPORT: ({ commit, dispatch, rootState }) => {
    // Consulta el endpoint que tiene la información del reporte
    // Se hace una sola consulta para opmitizar recursos, tiempos de descarga
    // Y para facilitar la renderización de información en los componentes creados
    return new Promise((resolve, reject) => {
      commit("setPillarsStatus", { status: "pending", key: "pillars" });
      const businessId = rootState.business.currentBusiness.id;
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      /*      commit('setBusinessStatus', { status: 'pending', key: 'business' })
            commit('setBusinessStatus', { status: 'pending', key: 'snapshots' })*/
      //    commit('setAssessmentStatus', { status: 'pending', key: 'assessment' })
      axiosCall({
        url: "Pillars/pillarsReport/" + businessId + "/" + snapshotId,
      })
        .then((resp) => {
          /*          /!* GET SNAPSHOT *!/
                    commit('setBusinessStatus', { status: 'success', key: 'snapshots' })
                    commit('setSnapshots', resp.data.snapshotsData)*/
          /* GET BUSINESS */
          /*      commit('setBusinessStatus', { status: 'success', key: 'business' })
                commit('setBusiness', resp.data.businessData)
                console.log('empiza')
                /!* GET SELF ASSESMENT*!/*/
          commit("setAssessmentStatus", {
            status: "success",
            key: "assessment",
          });
          if (resp.data.selfAssessmentData) {
            console.log("usar resp.data.selfAssessment......");
            commit("setSelfAssessment", resp.data.selfAssessmentData);
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_FIELDS_GENERAL_INFORMATION");
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY");
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_LABOR_CONDITIONS");
            commit("setEmploymentPolicies", resp.data.employmentPoliciesData);
            // commit('organizeEmploymentPolicies')
          } else {
            var tempSelfAssessment = state.selfAssessmentDefaultData;
            tempSelfAssessment.snapshotId = snapshotId;
            dispatch("SELF_ASSESSMENT_INITIAL_VALUES", tempSelfAssessment);
            dispatch("SELF_ASSESSMENT_UPDATE", tempSelfAssessment)
              .then(() => {
                commit("setSelfAssessment", tempSelfAssessment);
              })
              .catch((err) => {
                console.log(err);
              });
          }

          /* Pillars*/
          commit("setPillarsStatus", { status: "success", key: "pillars" });
          var pillars = resp.data.pillarsData.pillars.children;
          var pillarsIds = [];
          for (const pillar in pillars) {
            if (
              pillarsIds.filter((s) => s === pillars[pillar].id).length === 0
            ) {
              pillarsIds.push(pillars[pillar].id);
            }
          }
          commit("setReportData", resp.data.pillarsData);
          commit("setPillarsData", pillars);
          commit("setPillarsIds", pillarsIds);
          commit("setCurrentPillarId", "OP");
          commit("setCurrentIndicatorId", "OP1");
          commit("setGeneralIndex", resp.data.pillarsData.generalIndex);
          /* commit('setPillarsLastUpdate')*/

          resolve(resp);
        })
        .catch((err) => {
          commit("setPillarsStatus", { status: "error", key: "pillars" });
          reject(err);
        });
    });
  },
};

const mutations = {
  setPillarsStatus: (state, data) => {
    state.status[data.key] = data.status;
  },
  setReportData(state, data) {
    state.reportData = data;
  },
  setPillarsIds(state, pillarsIds) {
    state.pillarsIds = pillarsIds;
  },
  setPillarGlobalIds(state, pillarsIds) {
    state.pillarGlobalIds = pillarsIds;
  },
  setPillarsData(state, data) {
    // Esta lineas de código comentadas acá abajo sirven para colocar información de graficas de prueba
    /* data.map(i => { // Agregar datos falsos de las graficas temporalmente
      i.children.map(j => {
        j.chart = [addMockChart(i.id), addMockChart(i.id)]
      })
    })*/
    console.log("setPilarsData");
    console.log(data);
    state.pillarsData = data;
  },
  setGeneralIndex(state, number) {
    state.generalIndex = number;
  },
  setCurrentPillarId(state, pillarId) {
    state.currentPillarId = pillarId;
  },
  setCurrentIndicatorId(state, indicatorId) {
    state.currentIndicatorId = indicatorId;
  },
  pillarsReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

/* function addMockChart (id) {
  var type1 = {
    'xAxis': 'label_reports_opinionSurvey_gender',
    'yAxis': 'label_reports_graph_op_absent',
    'title': 'label_reports_genderGap_indicatorTable_op1_g1_title',
    'type': 'ChartBarSimple',
    data: [
      {
        'label': 'label_reports_graph_gender_men',
        'value': getRndInteger(25000, 32000), // Null o '' o N/A -> No se renderiza
        'percentage': getRndInteger(18, 22), // Si viene un entero (Se muestra con %) // null -> no se muestra este campo
        'type': 'integer' // Integer (Se muestra el numéro normal),
        // Currency (Se agrega el simbolo de dolar),
        // Percentage (Se muestra el eje sobre 100% y en rollover se muestran todos los valores)
      },
      {
        'label': 'label_reports_graph_gender_women',
        'value': getRndInteger(25000, 32000),
        'percentage': getRndInteger(18, 22),
        'type': 'integer'
      }]
  }

  var type2 = {
    'xAxis': 'label_reports_opinionSurvey_gender',
    'yAxis': 'label_reports_graph_op_absent',
    'title': 'label_reports_genderGap_indicatorTable_op1_g1_title',
    'type': 'ChartBarGrouped',
    data: [
      {
        'label': 'label_reports_graph_gender_men',
        'group': [
          {
            'label': 'label_reports_graph_stronglyDisagree',
            'value': getRndInteger(80, 100),
            'percentage': getRndInteger(18, 22),
            'type': 'integer'
          },
          {
            'label': 'label_reports_graph_disagree',
            'value': getRndInteger(80, 100),
            'percentage': getRndInteger(18, 22),
            'type': 'integer'
          },
          {
            'label': 'label_reports_graph_neitherAggreeNorDisagree',
            'value': getRndInteger(80, 100),
            'percentage': getRndInteger(18, 22),
            'type': 'integer'
          },
          {
            'label': 'label_reports_graph_agree',
            'value': getRndInteger(80, 100),
            'percentage': getRndInteger(18, 22),
            'type': 'integer'
          },
          {
            'label': 'label_reports_graph_stronglyAgree',
            'value': getRndInteger(80, 100),
            'percentage': getRndInteger(18, 22),
            'type': 'integer'
          }
        ]
      },
      {
        'label': 'label_reports_graph_gender_women',
        'group': [
          {
            'label': 'label_reports_graph_stronglyDisagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_graph_disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_graph_neitherAggreeNorDisagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_graph_agree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_graph_stronglyAgree',
            'value': getRndInteger(1, 100)
          }
        ]
      }
    ]
  }

  var type3 = {
    'xAxis': 'label_reports_opinionSurvey_gender',
    'yAxis': 'label_reports_graph_op_absent',
    'title': 'label_reports_genderGap_indicatorTable_op1_g1_title',
    'type': 'ChartBarStackedGrouped',
    'data': [{
      'group': 'Grupo 1',
      data: [{
        'label': 'label_reports_general_men',
        'group': [
          {
            'label': 'label_reports_opinionSurvey_strongly disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_neither agree nor disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_agree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_strongly agree',
            'value': getRndInteger(1, 100)
          }
        ]
      },
      {
        'label': 'label_reports_general_women',
        'group': [
          {
            'label': 'label_reports_opinionSurvey_strongly disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_neither agree nor disagree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_agree',
            'value': getRndInteger(1, 100)
          },
          {
            'label': 'label_reports_opinionSurvey_strongly agree',
            'value': getRndInteger(1, 100)
          }
        ]
      }
      ]
    },
    {
      'group': 'Grupo 2',
      data: [
        {
          'label': 'label_reports_general_men',
          'group': [
            {
              'label': 'label_reports_opinionSurvey_strongly disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_neither agree nor disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_agree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_strongly agree',
              'value': getRndInteger(1, 100)
            }
          ]
        },
        {
          'label': 'label_reports_general_women',
          'group': [
            {
              'label': 'label_reports_opinionSurvey_strongly disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_neither agree nor disagree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_agree',
              'value': getRndInteger(1, 100)
            },
            {
              'label': 'label_reports_opinionSurvey_strongly agree',
              'value': getRndInteger(1, 100)
            }
          ]
        }
      ]
    }]
  }

  var type4 = {
    'title': 'label_reports_managementReport_internalExternalCommunication_lettlerhead_title',
    'type': 'Table',
    data: [
      {
        'number': 'label_selfAssessment_employmentPolicies_internalCommunication_q1_number',
        'label': 'label_selfAssessment_employmentPolicies_internalCommunication_q1_inclusiveLanguage',
        'value': 'optionList_selfAssessment_employmentPolicies_responses_always',
        'value_class': 'always'
      },
      {
        'number': 'label_selfAssessment_employmentPolicies_internalCommunication_q2_number',
        'label': 'label_selfAssessment_employmentPolicies_internalCommunication_q2_accesibility',
        'value': 'optionList_selfAssessment_employmentPolicies_responses_always',
        'value_class': 'always'
      }
    ]
  }

  if (id === 'OP') {
    return type1
  } else if (id === 'PP') {
    type1.type = 'ChartPie'
    return type1
  } else if (id === 'RSH') {
    return type2
  } else if (id === 'PDP') {
    type2.type = 'ChartBarStacked'
    return type2
  } else if (id === 'R') {
    return type3
  } else {
    return type4
  }
}

function getRndInteger (min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}
*/
